import { Component, OnDestroy, OnInit } from '@angular/core';

import { ACQ } from '@atmi/core/models';
import { BaseCtrlValueAccessorFormComponent } from '@sim/form/components/base-ctrl-value-accessor-form.component';

@Component({
  selector: 'app-acq-form',
  styleUrls: ['./acq-form.component.scss'],
  templateUrl: './acq-form.component.html',
})
export class AcqFormComponent extends BaseCtrlValueAccessorFormComponent<ACQ> implements OnDestroy, OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

}
